<template>
    <div :id="nameDashed" :class="pageClasses">
        <oc-access-control v-bind="$_accessControl">
            <slot>
                <oc-dynamic-structure :schema="schema" />
            </slot>
        </oc-access-control>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'oc-page',
    props: {
        title: {
            type: String,
            required: true
        },
        permission: {
            type: String
        },
        mode: {
            type: String
        },
        titleFormat: {
            type: Function,
            default: (title) => title
        },
        applyMetaTitle: {
            type: Boolean,
            default: true
        },
        accessControl: {
            type: Object,
            default: () => ({})
        },
        schema: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        title: {
            handler: function (value) {
                this.setMetaTitle()
            },
            immediate: true
        }
    },
    computed: {
        nameDashed() {
            return 'page-' + this.$_permission.replace(/\./g, '-')
        },
        pageClasses() {
            return this.mode ? 'oc-page-' + this.mode : ''
        },
        $_permission() {
            return this.permission + (this.mode ? '.' + this.mode : '')
        },
        $_accessControl() {
            return Object.assign({
                mode: this.mode,
                permission: this.permission
            }, this.accessControl)
        }
    },
    methods: {
        setMetaTitle() {
            if( this.applyMetaTitle ) {
                document.title = this.titleFormat(this.title)
            }
        }
    }
}
</script>
